class Image {

    constructor(element) {

        this.element = element;
        const { src, srcset } = this.element.dataset;
        if(src) this.element.src = src;
        if(srcset) this.element.srcset = srcset;

    }

}

export default Image;


// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/demo.test/frontend/source/utilities/image.js